/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrIconModule } from "../icon/icon.module";
import { MODAL_DIRECTIVES } from "./index";
var ClrModalModule = (function () {
    function ClrModalModule() {
    }
    return ClrModalModule;
}());
export { ClrModalModule };
ClrModalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrIconModule
                ],
                declarations: [
                    MODAL_DIRECTIVES
                ],
                exports: [
                    MODAL_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrModalModule.ctorParameters = function () { return []; };
//# sourceMappingURL=modal.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/modal/modal.module.js
// module id = 60
// module chunks = 4